class ProductEquipment extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.initSlider()
  }

  initSlider() {
    this.slider = new Swiper(this.querySelector('.product-equipment .swiper'), {
      slidesPerView: 1.05,
      spaceBetween: 16,
      autoHeight: false,
      navigation: {
        nextEl: '.product-equipment .product-gallery__slide-button--next',
        prevEl: '.product-equipment .product-gallery__slide-button--prev',
      },
      pagination: {
        el: '.product-equipment .swiper-pagination',
        type: 'progressbar',
      },
      breakpoints: {
        749: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
      },
    })
  }
}

if (!customElements.get('product-equipment')) {
  customElements.define('product-equipment', ProductEquipment)
}